import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Scanner } from '@yudiel/react-qr-scanner';
import "./QrCodeScanner.css"

const QrCodeScanner = () => {
    const { t } = useTranslation("translation", { keyPrefix: "qrCodeScanner" });
    const [qrData, setQrData] = useState('');
    const navigate = useNavigate();

    const handleDecode = (data) => {
        if (data) {
            console.log(data)
            // setQrData(data[0].rawValue);
            const url = data[0].rawValue
            const params = new URLSearchParams(new URL(url).search)
            const uid = params.get('uid')
            const numbers = params.get('numbers')
            if (uid && numbers) {
                navigate(`/scanLanding?uid=${uid}&numbers=${numbers}`)
            } else {
                setQrData("Broken scan lol")
            }
        }
    };
    return (
        <div className="full-scan-container">
            <div className="scannerDiv">
                {qrData ? (
                    <>
                        <p className="scan-text">{t("badscan", "Scan was invalid, please try again!")}</p>
                    </>
                ) : (
                    <p className="scan-text">{t("waiting", "PLEASE SCAN THE QR CODE ON THE bOOTH TO BEGIN YOUR SESSION")}</p>
                )}
                <div
                    className="video-container"
                    style={{}}
                >
                    <Scanner
                        onScan={handleDecode}
                        onError={(error) => console.error(t('scanError'), error)}
                        allowMultiple={true}
                    // videoStyle={{ width: '100%' }}
                    />
                </div>
            </div>
        </div>

    );
};

export default QrCodeScanner;
